import React from "react";
import { useTranslation } from "react-i18next";
import UploadInnovationData from "./UploadInnovationData";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ImportDataInnovationScreen = () => {
  debugLogPages(':: ImportDataInnovationScreen');

  const { t } = useTranslation();

  return (
    <>
      <NavbarIconsGenericComponent componentName="ImportDataInnovation" />

      <div className="d-flex justify-content-center page-title">{t("admin.importdata.innovation.title")}</div>

      <hr className="line-hr" />

        <div>
        <UploadInnovationData />
        </div>
      
    </>
  );
};

export default ImportDataInnovationScreen;
